<template>
<div class="row">
	<div class="col-lg-12">
		<div class="p-5">
			<div class="text-center mb-2 ">
				<h3>訂閱</h3>
				<hr>
			</div>
			<el-form
				ref="ruleFormRef"
				:model="form"
				:rules="rules"
				label-position="top"
        label-width="120px"
			>
				<h5 class="black text-center">方案</h5>
				<div class="form-group row">
					<el-radio-group v-model="form.plan_id" size="large" class="w-100 row m-0 justify-content-center">
						<el-radio
						v-for="plan in plans"
						:key="plan.id"
						:label="plan.id"
						border
						class="col-12 col-md-4 mb-2 mx-1"
						:style="{ minHeight: '7rem', margin: '0 0rem 0 0' }"
						>
						{{ plan.name }} ({{ checkValidCurrencyStr(plan.amount, plan.currency) }})
						<div class="text-black-50 text-wrap">
							{{ plan.description }}
						</div>
						<div class="text-primary">
							計費週期：每 {{ plan.interval_count }}
							<span v-if="plan.interval == 'day'">天</span>
							<span v-else-if="plan.interval == 'week'">週</span>
							<span v-else-if="plan.interval == 'month'">月</span>
							<span v-else-if="plan.interval == 'year'">年</span>
							<span v-else>{{ plan.interval }}</span>
							結帳
						</div>
						</el-radio>
					</el-radio-group>
				</div>
				<h5 class="black text-center">付款方式</h5>
				<div class="form-group row">
					<el-radio-group v-model="form.payment_type" size="large" class="w-100 row m-0 justify-content-center">
						<el-radio
						v-for="payment in payments"
						:key="payment.type"
						:label="payment.type"
						border
						class="col-12 col-md-4 mb-2 mx-1"
						:style="{ minHeight: '5rem', margin: '0 0rem 0 0' }"
						>
							{{ dt(payment.name_translations) }}
							<div class="text-black-50 text-wrap">{{ dt(payment.description_translations) }}</div>
						</el-radio>
					</el-radio-group>
				</div>

				<InvoiceInfo
	        v-model="form"
	        :state="state"
	        :provice-map="proviceMap"
	        :used-logistic-types="[]"
	        :enableEInvoice="enableEInvoice"
	      ></InvoiceInfo>

				<h5 class="black text-center">推薦碼</h5>
				<div class="form-group row justify-content-center text-center">
					<div class="col-6">
						<el-input v-model="form.invited_by_code" placeholder="推薦碼" :readonly="form.invited_by_code != null"></el-input>
						<p v-if="invited_by_code != null" class="text-primary">推薦人已綁定</p>
					</div>
				</div>

				<div v-if="choosePlan != null" class="d-flex justify-content-between px-3 py-2 bg-faded-dark rounded">
					<div>已選擇 <span class="text-primary">{{ choosePlan.name }}</span></div>
					<div class="text-primary">{{ checkValidCurrencyStr(choosePlan.amount, choosePlan.currency) }}</div>
				</div>
				<el-button type="primary" class="btn btn-primary btn-user btn-block mt-3" @click="executeSubmit(ruleFormRef)">
				前往繳費
				</el-button>
			</el-form>
		</div>
	</div>
</div>
</template>
<script setup>
import { reactive, ref, computed, onMounted } from 'vue'
import { dataTranslations as dt, checkValidCurrencyStr, notificationErrors } from "../utils"
import { _api_postSubscription } from "../api/index.js"
import { useI18n } from "vue-i18n"
import InvoiceInfo from "./checkout/InvoiceInfo.vue"

const { t, locale } = useI18n()

const props = defineProps({
	invoice_type: String,
	country: String,
	plans: Object,
	payments: Object,
	invitation_code: String,
	invited_by_code: String,
})

const ruleFormRef = ref()
const form = reactive({
	country: props.country,
	// 方案
	plan_id: props.plans?props.plans[0].id:null,
	// 付款方式
	payment_type: props.payments?props.payments[0].type:null,
	// 發票
  invoice_type: "invoice",
  invoice_relation_option: "PAPER",
  invoice_relation_value: null,
  invoice_paper_no: null,
  invoice_paper_title: null,
  invoice_paper_relation_mobile: null,
  invoice_donate_code: "168001",
  invoice_province: null,
  invoice_city: null,
  invoice_region: null,
  invoice_postal_code: null,
  invoice_address: null,
  // 推薦碼
	invited_by_code: props.invitation_code,
})
const state = reactive({
	invoice_type: props.invoice_type,
	countryMap: null,
	invoiceDonateOptions: [
    { label: "(168001) 財團法人ＯＭＧ關懷社會愛心基金會", value: "168001" },
    { label: "(1577) 社團法人中華民國自閉症總會", value: "1577" },
    { label: "(6274) 中華民國災難救援協會", value: "6274" },
  ],
})

const rules = reactive({
	invoice_type: [
    { required: true, message: t('errors.pleaseSelect', [t("invoices.type")]), trigger: 'change' },
  ],
  invoice_paper_no: [
    { required: true, message: t('errors.pleaseInput', [t("invoices.uniformNumbers")]), trigger: 'blur' },
  ],
  invoice_paper_title: [
    { required: true, message: t('errors.pleaseInput', [t("invoices.companyName")]), trigger: 'blur' },
  ],
  invoice_relation_value: [
    { required: true, message: t('errors.pleaseInput', [t("invoices.carrierCode")]), trigger: 'blur' },
  ],
  invoice_province: [
    { required: true, message: t('errors.pleaseSelect', [t("users.province")]), trigger: 'change' },
  ],
  invoice_city: [
    { required: true, message: t('errors.pleaseSelect', [t("users.city")]), trigger: 'change' },
  ],
  invoice_region: [
    { required: true, message: t('errors.pleaseSelect', [t("users.region")]), trigger: 'change' },
  ],
  invoice_postal_code: [
    { required: true, message: t('errors.pleaseInput', [t("users.postcode")]), trigger: 'blur' },
  ],
  invoice_address: [
    { required: true, message: t('errors.pleaseInput', [t("orders.toAddress")]), trigger: 'blur' },
  ],
})


const enableEInvoice = computed(() => {
  if (state.invoice_type == "ELECTRONIC") {
    return true
  }
  return false
})
const choosePlan = computed(() => {
	if (form.plan_id) {
		return props.plans.find((plan) => plan.id == form.plan_id)
	}
})
const proviceMap = computed(() => {
  if (form.country) {
    return state.countryMap?.province || {};
  }
  return {};
});

const setCountryMap = (country) => {
  if (country) {
    const country_code = country.toLowerCase()
    axios({
      method: 'GET',
      url: "/api/v1/data/iso-3166-ext/"+country_code,
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => {
      // console.log(res)
      state.countryMap = res.data
    })
    .catch((err) => {
      return Promise.reject(err.response)
    })
  } else {
    state.countryMap = {}
  }
}

const createSubscription = async () => {
	window.fullPageLoading("show")
	_api_postSubscription(form)
	.then(async (res) => {
		if (res.status == 200) {
			const redirect_url = res.data.redirect_url
			window.location.assign(redirect_url)
		}
	})
	.catch((error) => {
		console.log("createSubscription Fail: ", error)
		notificationErrors(error.response.data)
	})
	.finally(() => {
		window.fullPageLoading("hide")
	})
}

const executeSubmit = async (formEl) => {
  if (!formEl) return
 	// console.log("executeSubmit", ruleFormRef.value)

	await formEl.validate(async (valid, fields) => {
		if (valid) {
			createSubscription()
		} else {
			for (const key in fields) {
				if (["invoice_relation_value", "invoice_paper_no", "invoice_paper_title"].includes(key)) {
          formEl.scrollToField("invoice")
          break
        } else {
          // console.log('error submit!', key)
          formEl.scrollToField(Object.keys(fields)[0])
          console.log('error submit!', fields)
          break
        }
			}
		}
  })
}

onMounted(() => {
  setCountryMap(props.country)
})
</script>